import _ from 'lodash';
import { connect } from 'react-redux';
import { add, update, get, remove } from '../../modules/inventory/fuelContract';
import { showErrors } from '../../modules/general';
import { search as searchSuppliers } from '../../modules/logistics/supplier';
import { search as searchFuelSubContracts, remove as removeFuelSubContract } from '../../modules/inventory/fuelSubContract';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	const fuelContractId = _.get(ownProps, ['match', 'params', 'fuelContractId']);
	const fuelContract = (fuelContractId) ? _.get(state.maps, ['fuelContract', fuelContractId]) : undefined;

	const suppliers = state.lists.supplierIds
		? _.map(state.lists.supplierIds, id => state.maps.supplier[id])
		: [];

	return {
		fuelContract,
		userMap : state.maps.user,
		supplierMap : state.maps.supplier,
		terminalMap : state.maps.terminal,
		resourceMap : state.maps.resource,
		suppliers,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	addFuelContract : add,
	updateFuelContract : update,
	getFuelContract : get,
	archiveFuelContract : remove,
	showErrors,
	searchSuppliers,
	searchFuelSubContracts,
	removeFuelSubContract,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
